/*Detecta si es un dispositivo movil o no...*/
const body = document.querySelector("body");
function detectarDispositivo() {
  const userAgent = navigator.userAgent;
  const anchoPantalla = window.innerWidth;
  const esCelular = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) || anchoPantalla < 768;
  if (esCelular) {
    document.body.classList.add('data-browser-cel');
  } else {
    document.body.classList.add('data-browser-pc');
  }
}

// Configuración principal
const config = {
    timeouts: {
        init: 1000,
        columnSwitch: 500
    },
    selectors: {
        filters: {
            container: '#positionfiltrosTopAllSite',
            reference: 'input[name="q"]',
            category: '#categoriasTopSelect',
            size: '#tallasTopSelect',
            color: '#colorTopSelect',
            button: '#encuentraTutalla'
        },
        menu: '.m-menu-drawer__navigation > li',
        products: '.m-collection-products'
    }
};

// Clase principal para manejar los filtros
class FilterManager {
    constructor() {
        this.elements = {};
        this.initialized = false;
    }

    init() {
        // Inicializar elementos
        this.elements = {
            reference: document.querySelector(config.selectors.filters.reference),
            category: document.getElementById('categoriasTopSelect'),
            size: document.getElementById('tallasTopSelect'),
            color: document.getElementById('colorTopSelect'),
            button: document.getElementById('encuentraTutalla')
        };

        if (!this.validateElements()) return false;

        this.setupEventListeners();
        this.updateInitialState();
        return true;
    }

    validateElements() {
        return Object.values(this.elements).every(element => element !== null);
    }

    setupEventListeners() {
        // Event listeners para filtros
        ['category', 'size', 'color'].forEach(filter => {
            this.elements[filter]?.addEventListener('change', () => {
                this.elements.reference.value = '';
                this.updateURL();
            });
        });

        // Event listener para referencia
        this.elements.reference?.addEventListener('input', () => {
            if (this.elements.reference.value.trim()) {
                this.resetFilters();
            }
            this.updateURL();
        });
    }

    resetFilters() {
        ['category', 'size', 'color'].forEach(filter => {
            if (this.elements[filter]) this.elements[filter].value = '';
        });
    }

    updateURL() {
        const reference = this.elements.reference.value.trim();

        if (reference) {
            this.elements.button.href = `${window.location.origin}/search?sort_by=title-descending&filter.v.availability=1&q=${reference.toUpperCase()}`;
            return;
        }

        const params = new URLSearchParams();
        params.append("filter.v.availability", "1");

        const category = this.elements.category.value;
        const size = this.elements.size.value;
        const color = this.elements.color.value;

        if (size) params.append("filter.v.option.tallas", size);
        if (color) params.append(...color.split('='));

        const url = `${window.location.origin}${category || window.location.pathname}`;
        this.elements.button.href = `${url}${params.toString() ? '?sort_by=title-descending&' + params.toString() : ''}`;
    }

    updateInitialState() {
        this.updateURL();
    }
}

// Clase para manejar la UI
class UIManager {
    static initializeDeviceDetection() {
        const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(
            navigator.userAgent.toLowerCase()
        ) || window.innerWidth < 768;
        
        document.body.classList.add(isMobile ? 'data-browser-cel' : 'data-browser-pc');
        return isMobile;
    }
    static createCategorySelect() {
        const container = document.getElementById('filtrosCategtorias');
        if (!container) return;

        const select = document.createElement('select');
        select.id = 'categoriasTopSelect';
        select.name = 'categoriasTopSelect';
        select.className = 'm-product-option--node';

        // Agregar opción por defecto
        select.appendChild(this.createOption('', 'Categoría', true));

        // Agregar opciones del menú
        const menuItems = document.querySelectorAll(config.selectors.menu);
        menuItems.forEach(item => this.processMenuItem(item, select));

        const wrapper = document.createElement('div');
        wrapper.className = 'm-product-option m-product-option--dropdown';
        wrapper.appendChild(select);
        container.appendChild(wrapper);
    }
    static createOption(value, text, isDefault = false) {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = text;
        if (isDefault) option.className = 'm-product-option--node';
        return option;
    }
    static processMenuItem(item, select) {
        const link = item.querySelector('a.m-menu-mobile__link');
        if (!link) return;

        select.appendChild(this.createOption(link.getAttribute('href'), link.textContent.trim()));

        const submenuItems = item.querySelectorAll('.m-submenu-mobile a');
        submenuItems.forEach(subItem => {
            select.appendChild(this.createOption(
                subItem.getAttribute('href'),
                `- ${subItem.textContent.trim()}`
            ));
        });
    }
    static initializeColumnSwitcher() {
        setTimeout(() => {
            const isMobile = document.body.classList.contains('data-browser-cel');
            const columnNumber = isMobile ? "1" : "4";
            const columnButton = document.querySelector(`.m-toolbar--column-switcher button[data-column="${columnNumber}"]`);
            if (columnButton) {
                columnButton.click();
                console.log(`Columna ${columnNumber} activada automáticamente`);
            }
        }, 2000); // Espera 2 segundos
    }
    static modificarEnlacesMenu() {
        const menuLinks = document.querySelectorAll('#m-menu-drawer a');
        menuLinks.forEach(link => {
            const href = link.getAttribute('href');
            if (href && !href.includes('shopify.com')) {
                const nuevaURL = `${href}${href.includes('?') ? '&' : '?'}sort_by=title-descending&filter.v.availability=1`;
                link.setAttribute('href', nuevaURL);
            }
        });
    }
}

// inicialización
document.addEventListener('DOMContentLoaded', () => {
    detectarDispositivo();
    setTimeout(() => {
        UIManager.modificarEnlacesMenu();  // Llamar al método aquí
        UIManager.createCategorySelect();
        const filterManager = new FilterManager();
        if (filterManager.init()) {
            UIManager.initializeDeviceDetection();
            UIManager.initializeColumnSwitcher();
        }
    }, config.timeouts.init);
});